﻿export * from './cliente.model';
export * from './endereco.model';
export * from './login-param.model';
export * from './login-result.model';
export * from './ordem-servico.model';
export * from './tipo-os.model';
export * from './usuario-logado.model';
export * from './paginacao-param.model';
export * from './ordem-servico-in.model';
export * from './buscar-ordem-servico-in.model';
export * from './primeiroacesso.model';
export * from './ativo.model';
export * from './ativo-param.model';
export * from './tipoos-ativo-param.model';
